import { render, staticRenderFns } from "./AppDownloadPage.vue?vue&type=template&id=4f3a8396&scoped=true"
import script from "./AppDownloadPage.vue?vue&type=script&lang=js"
export * from "./AppDownloadPage.vue?vue&type=script&lang=js"
import style0 from "./AppDownloadPage.vue?vue&type=style&index=0&id=4f3a8396&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3a8396",
  null
  
)

export default component.exports